import store from '@/store';

const axios = require('axios').default;
axios.defaults.timeout = 30000; // 30 seconds

axios.interceptors.request.use(
  (config) => {
    config.headers.MQTECH_REQUEST_KEY = process.env.VUE_APP_MQ_TECH_API_KEY;

    const session = localStorage.getItem('session');
    if (session) config.headers.session = session;

    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const { code, response } = error;

    if (code === 'ECONNABORTED') {
      // Handle request timeout error
      await store.dispatch('showAlertSnackBar', { text: 'Something went wrong. Please try again' });
    } else if (response?.status === 403 && response?.data?.message === 'SESSION_EXPIRED') {
      await store.dispatch('handleExpiredSession');
    } else if (response?.status === 403 && response?.data?.message === 'ALREADY_IN_GAME') {
      await store.dispatch('handleUserIsInGameAlready');
    } else if (response?.status === 403 && response?.data?.message === 'ACCESS_RESTRICTED') {
      await store.dispatch('handleRestrictedAccess', response.data);
    } else if (response?.status === 401 && response?.data?.message === 'UNAUTHORIZED') {
      await store.dispatch('handleUnauthorizedAccess', response.data);
    } else {
      // Handle rest of the errors
    }

    return Promise.reject(error);
  },
);

export default axios;
